import { type FC } from "react";
import { useTranslation } from "react-i18next";
import CompactDialog from "../../../../components/CompactDialog";

interface DeleteSymbolDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteSymbolDialog: FC<DeleteSymbolDialogProps> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <CompactDialog
      open={open}
      title={t("configuration.ingenieurslegende.deleteDialogTitle")}
      message={t("configuration.ingenieurslegende.deleteDialogMessage")}
      confirmText={t("common.delete")}
      cancelText={t("common.cancel")}
      confirmColor="primary"
      iconColor="error"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default DeleteSymbolDialog;
